import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import { Observable } from 'rxjs';
import { EmployeeDto } from '../../../core/data/new-dtos/employee.dtos';
import { SupervisorBranchDto } from '../../../core/data/new-dtos/supervisor.dtos';

@Injectable({ providedIn: 'root' })
export class SupervisorsService extends BaseCrudService<EmployeeDto> {
  controller = 'Supervisors';

  // GET /api/Supervisors/{azureId}/branches
  getBranches(azureId: string): Observable<SupervisorBranchDto[]> {
    return this.httpClient.get<SupervisorBranchDto[]>(
      `${this.controller}/${encodeURIComponent(azureId)}/branches`,
    );
  }

  // GET /api/Supervisors/{azureId}/employees?branchId&role&status
  getEmployees(
    azureId: string,
    params?: { branchId?: number; role?: string; status?: string },
  ): Observable<EmployeeDto[]> {
    const query = params
      ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => {
          if (v !== undefined && v !== null && v !== '') acc[k] = String(v);
          return acc;
        }, {} as Record<string, string>)).toString()
      : '';
    return this.httpClient.get<EmployeeDto[]>(
      `${this.controller}/${encodeURIComponent(azureId)}/employees${query}`,
    );
  }
}
